// hooks/useAppointmentAction.ts
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import { ExpertRole } from "@/features/experts/types/ExpertRole"
import { saveEvent } from "@/utils/apis/user-service"
import { AppointmentAction } from "../types/AppointmentAction"

export const useAppointmentAction = (email: string | null, expertRole: ExpertRole) => {
  const { sendEvent } = useCreateEvent()

  return async ({ url, action }: { url: string; action: AppointmentAction }) => {
    window.open(url)
    if (!email) return

    saveEvent(
      email,
      `${action}_click`,
      (success) => console.log(),
      (error) => console.error(error),
      "appointment_card"
    )

    await sendEvent({
      event: EventType.BUTTON_CLICK,
      sub_category: "action_button",
      event_metadata: {
        action,
        expert: expertRole,
      },
    })
  }
}